import React, { Fragment, useState } from "react";
import { Form, Input, Switch, Button } from "antd";
import { ReactSVG } from "react-svg";

const MobileVersionForm = ({
	handleSubmitForm,
	form,
	mobileVersionId,
	handleCancel,
}) => {
	const [version, setVersion] = useState({});
	const tips = "z.y.z are number";

	function validateVersion(number) {
		if (number !== "") {
			const numberArray = number.split(".");
			if (numberArray.length < 4) {
				const regex = /^-?\d+$/;
				const result = numberArray.find((e) => !regex.test(e));
				if (result && result !== null) {
					return {
						validateStatus: "error",
						errorMsg: "invalid",
					};
				} else {
					return {
						validateStatus: "success",
						errorMsg: null,
					};
				}
			} else {
				return {
					validateStatus: "error",
					errorMsg: "invalid",
				};
			}
		} else {
			return {
				validateStatus: "error",
				errorMsg: "is require",
			};
		}
	}

	const onVersionChange = (event) => {
		const value = event.target.value;
		setVersion({ ...validateVersion(value), value });
	};

	return (
		<Fragment>
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Version"
						name="version"
						hasFeedback
						validateStatus={version.validateStatus}
						help={version.errorMsg || tips}
					>
						<Input placeholder="x.y.z" onChange={onVersionChange} />
					</Form.Item>
					<Form.Item label="Description" name="description">
						<Input.TextArea rows={3} />
					</Form.Item>
					<Form.Item
						label="Force Update"
						name="force_update"
						valuePropName="checked"
					>
						<Switch />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn btn-primary">
						{mobileVersionId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</Fragment>
	);
};

export default MobileVersionForm;
